export default "__VITE_ASSET__BZGaUOFZ__"